import { MousePositionProvider } from 'components/app/_mediator/app-cursor-position.provider';
import { ClipThumbPrevProvider } from 'components/app/_mediator/clip-thumb-prev.provider';
import { DraggerProvider } from 'components/app/_mediator/app-dragger.provider';
import { ZoomProvider } from 'components/app/_mediator/zoom/lib/zoom.provider';
import { ClipThumbProvider } from 'components/app/_mediator/clip-thumb/clip-thumb.provider';
import { AudioTrackProvider } from 'components/app/audio-track/_mediator/audio-track.provider';
import { WsMarkersProvider } from 'components/app/audio-track/_mediator/ws-markers.provider';
import { SelectorProvider } from 'components/app/selector/_mediator/selector.provider';
import { PanZoomProvider } from 'components/app/editor/pan-zoom/_pan-zoom.provider';
import { SbProvider } from 'components/app/storyboard/_mediator/sb.provider';
import { SbRegionProvider } from 'components/app/storyboard/_mediator/draft__sb-region.provider';
import { SbPanZoomProvider } from 'components/app/storyboard/sb-pan-zoom/sb-pan-zoom.provider';
import { SbPlayerProvider } from 'components/app/storyboard/sb-player/_mediator/sb-player.provider';
import { FinalcutProvider } from 'components/app/finalcuts/_mediator/finalcut.provider';

export const providers = [
  MousePositionProvider,
  SbPanZoomProvider,
  ZoomProvider,
  WsMarkersProvider,
  AudioTrackProvider,
  SelectorProvider,
  PanZoomProvider,
  DraggerProvider,
  SbProvider,
  SbPlayerProvider,
  FinalcutProvider,
  SbRegionProvider,
  ClipThumbProvider,
  ClipThumbPrevProvider,
];
